import angular from 'angular';
import entitlerComponent from './entitler.component';

let entitlerModule = angular.module('entitler', []).component('entitler', entitlerComponent);

export default entitlerModule;



// WEBPACK FOOTER //
// ./app/components/entitler/entitler.js